import { useContext, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { AxiosContext } from "services/axios.context";

const useUpdateReleaseStatus = (releaseId) => {
  const { client } = useContext(AxiosContext);
  const [error, setError] = useState("");
  const queryClient = useQueryClient();
  return {
    updateReleaseStatus: useMutation(
      (status) =>
        client
          .post(`releases/${releaseId}/status/`, { new: status })
          .then((res) => res.data),
      {
        onSuccess: () => {
          queryClient.invalidateQueries("releases");
          queryClient.invalidateQueries(`release-${releaseId}`);
        },
      }
    ),
    error: error,
  };
};

export default useUpdateReleaseStatus;
